import React from "react";
import { useTranslation } from "react-i18next";

/**
 * "Answers are AI-generated" notice shown under every chat composer, as
 * required by Article 50 of the EU AI Act. Rendered by the composer components
 * themselves so no chat surface can ship without it.
 */
export const ChatAiDisclaimer = () => {
  const { t } = useTranslation();
  return <p className="mt-1.5 text-center text-[11px] text-text-dim">{t("chat_ai_disclaimer")}</p>;
};
